import { writable } from 'svelte/store';
export var MessageStore;
(function (MessageStore) {
    MessageStore.fullScreenMessage = writable(null);
    MessageStore.cornerMessage = writable(null);
    const emptyCallback = () => {
    };
    class CornerMessageData {
        constructor(message) {
            this.message = message;
        }
    }
    MessageStore.CornerMessageData = CornerMessageData;
    class FullScreenMessageData {
        constructor() {
            this.description = '';
        }
    }
    MessageStore.FullScreenMessageData = FullScreenMessageData;
    let ConfirmMessageType;
    (function (ConfirmMessageType) {
        ConfirmMessageType[ConfirmMessageType["information"] = 0] = "information";
        ConfirmMessageType[ConfirmMessageType["warning"] = 1] = "warning";
        ConfirmMessageType[ConfirmMessageType["danger"] = 2] = "danger";
    })(ConfirmMessageType = MessageStore.ConfirmMessageType || (MessageStore.ConfirmMessageType = {}));
    class LinkButtonData {
    }
    MessageStore.LinkButtonData = LinkButtonData;
    class RequestButtonData {
    }
    MessageStore.RequestButtonData = RequestButtonData;
    class ConfirmMessageData {
        constructor(message, positiveCallback) {
            this.type = ConfirmMessageType.information;
            this.description = '';
            this.negativeCallback = null;
            this.positiveMessage = 'OK';
            this.negativeMessage = 'キャンセル';
            this.linkButton = null;
            // 毎回新しい項目だと認識するための変数
            this.time = new Date().getTime();
            this.message = message;
            this.positiveCallback = positiveCallback;
        }
        getTime() {
            return this.time;
        }
    }
    MessageStore.ConfirmMessageData = ConfirmMessageData;
    MessageStore.confirmMessage = writable(null);
    /**
     * 単純なメッセージ表示
     * @param message
     * @param description
     */
    function showConfirmInformation(message, description = '') {
        const confirmMessageData = new MessageStore.ConfirmMessageData(message, emptyCallback);
        confirmMessageData.type = ConfirmMessageType.information;
        if (description !== '') {
            confirmMessageData.description = description;
        }
        MessageStore.confirmMessage.set(confirmMessageData);
    }
    MessageStore.showConfirmInformation = showConfirmInformation;
    /**
     * OK,Cancelメッセージ表示
     * @param message
     * @param positiveCallback
     */
    function showConfirmInformationOKCancel(message, positiveCallback, negativeCallback = emptyCallback) {
        const confirmMessageData = new MessageStore.ConfirmMessageData(message, positiveCallback);
        confirmMessageData.type = ConfirmMessageType.information;
        confirmMessageData.positiveMessage = "OK";
        confirmMessageData.negativeMessage = "Cancel";
        confirmMessageData.negativeCallback = negativeCallback;
        MessageStore.confirmMessage.set(confirmMessageData);
    }
    MessageStore.showConfirmInformationOKCancel = showConfirmInformationOKCancel;
    /**
     * Yes,Noメッセージ表示
     * @param message
     * @param positiveCallback
     * @param negativeCallback
     */
    function showConfirmInformationYesNo(message, positiveCallback, negativeCallback = emptyCallback) {
        const confirmMessageData = new MessageStore.ConfirmMessageData(message, positiveCallback);
        confirmMessageData.type = ConfirmMessageType.information;
        confirmMessageData.positiveMessage = "Yes";
        confirmMessageData.negativeMessage = "No";
        confirmMessageData.negativeCallback = negativeCallback;
        MessageStore.confirmMessage.set(confirmMessageData);
    }
    MessageStore.showConfirmInformationYesNo = showConfirmInformationYesNo;
    /**
     * 警告確認メッセージ表示
     * @param message
     * @param description
     */
    function showConfirmWarning(message, description = '') {
        const confirmMessageData = new MessageStore.ConfirmMessageData(message, emptyCallback);
        confirmMessageData.type = ConfirmMessageType.warning;
        if (description !== '') {
            confirmMessageData.description = description;
        }
        MessageStore.confirmMessage.set(confirmMessageData);
    }
    MessageStore.showConfirmWarning = showConfirmWarning;
    /**
     * 危険確認メッセージ表示
     * @param message
     * @param description
     * @param linkButton
     */
    function showConfirmDanger(message, description = '', linkButton = null) {
        const confirmMessageData = new MessageStore.ConfirmMessageData(message, emptyCallback);
        confirmMessageData.type = ConfirmMessageType.danger;
        if (description !== '') {
            confirmMessageData.description = description;
        }
        if (linkButton != null) {
            confirmMessageData.linkButton = linkButton;
        }
        MessageStore.confirmMessage.set(confirmMessageData);
    }
    MessageStore.showConfirmDanger = showConfirmDanger;
    /**
     * 危険 Yes,Noメッセージ表示
     * @param message
     * @param positiveCallback
     */
    function showConfirmDangerYesNo(message, positiveCallback) {
        const confirmMessageData = new MessageStore.ConfirmMessageData(message, positiveCallback);
        confirmMessageData.type = ConfirmMessageType.danger;
        confirmMessageData.positiveMessage = "Yes";
        confirmMessageData.negativeMessage = "No";
        confirmMessageData.negativeCallback = emptyCallback;
        MessageStore.confirmMessage.set(confirmMessageData);
    }
    MessageStore.showConfirmDangerYesNo = showConfirmDangerYesNo;
    /**
     * 確認メッセージ表示
     * @param confirmMessageData
     */
    function showConfirm(confirmMessageData) {
        MessageStore.confirmMessage.set(confirmMessageData);
    }
    MessageStore.showConfirm = showConfirm;
})(MessageStore || (MessageStore = {}));
